import { useLingui } from '@lingui/react/macro';
import { useCallback, useState } from 'react';
import { NavigateFunction } from 'react-router-dom';
import Modal from 'ud-ui/components/modal';

interface PreventNavigationModalProps {
  navigationTx?: {
    id: string;
    status: string;
  };
  nextLocation: string | number | null;
  targetPath: string | null;
  confirmNavigation: () => void;
  navigate: NavigateFunction;
  defaultPath?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
}

export function usePreventNavigationModal(props: PreventNavigationModalProps) {
  const { navigationTx, nextLocation, targetPath, confirmNavigation, navigate, onConfirm, onCancel, defaultPath } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useLingui();

  const openLeaveModal = useCallback(() => {
    setModalOpen(true);
  }, []);

  const closeLeaveModal = useCallback(() => {
    setModalOpen(false);
  }, []);

  const handleCancel = useCallback(() => {
    closeLeaveModal();
    onCancel?.();
  }, [closeLeaveModal, onCancel]);

  const handleConfirmLeave = useCallback(() => {
    closeLeaveModal();
    onConfirm?.();

    setTimeout(() => {
      if (navigationTx) {
        confirmNavigation();
      } else if (nextLocation) {
        if (typeof nextLocation === 'number') {
          navigate(nextLocation);
        } else {
          navigate(nextLocation.toString());
        }
      } else if (targetPath) {
        navigate(targetPath);
      } else if (defaultPath) {
        navigate(defaultPath);
      }
    }, 0);
  }, [closeLeaveModal, onConfirm, navigationTx, nextLocation, targetPath, confirmNavigation, navigate, defaultPath]);

  const modal = useCallback(() => {
    return (
      <Modal.Confirm
        show={modalOpen}
        title={t`Несохранённые изменения`}
        description={t`У вас есть несохранённые изменения. Вы уверены, что хотите покинуть страницу?`}
        confirmText={t`Покинуть`}
        onConfirm={handleConfirmLeave}
        onCancel={handleCancel}
      />
    );
  }, [handleCancel, handleConfirmLeave, modalOpen, t]);

  return { openLeaveModal, closeLeaveModal, Modal: modal };
}
